


<div class="container text-left mt-5" style="background-color: #13112E;
color: white;" *ngIf="queryParam.id === '543'">
    <p style="text-align: left;">1. GamezinePlus is a subscription-based mobile gaming service that offers unlimited
        mobile games to download and play as long as you have an active subscription.</p>
    <p class="qes" style="font-weight: 700;">2. What are features of GamezinePlus?</p>
    <p>The GamezinePlus is available to all active smart / feature phone Ncell prepaid and postpaid subscribers who
        subscribe to any of the different game plans available. The subscribers can download and play one or all the
        games on their phones during the validity of the subscription/plan. GamezinePlus has more exciting games of
        different genres to engage users of different age groups. Once you are subscribed to GamezinePlus
        subscription
        service, you will need an active data connection to be able to validate your subscription status and
        download the games. Data charges will be applicable for downloading the selected games.</p>

    <p>You can subscribe/unsubscribe this service through SMS mode by following instructions mentioned below.</p>
    <p class="qes" style="font-weight: 700;">3. How can I opt for GamezinePlus Service in Web?</p>
    <p>You can subscribe to GamezinePlus service by selecting the pack on <a
            href="https://bit.ly/gameznpls">http://GamezinePlus.matrixadz.com/</a></p>

    <p class=" qes mt-3" style="font-weight: 500;"><u>How much do I pay for subscribing to GamezinePlus?</u></p>
    <p>1.You can subscribe to different subscription plans for GamezinePlus. It is available in both upfront (one
        time)
        and instalments packs as mentioned in table below.</p>
    <table class="table table-bordered" style="background-color: #13112E;
    color: white;">
        <thead>
            <tr>
                <th scope="col">Service packages</th>
                <th scope="col">Charging Type</th>
                <th scope="col">Validity</th>
                <th scope="col">Price Incl of Tax</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td scope="row">6 Month 3 Days Installment pack for Rs. 900</td>
                <td>Installment</td>
                <td>180</td>
                <td>15 per 3 day</td>
            </tr>
        </tbody>
    </table>

    <p class="qes" style="font-weight: 700;">4. Which platforms are supported for this service?</p>
    <p>Android, iOS &Java platforms are supported in this service.</p>

    <p class="qes" style="font-weight: 700;">5. Can I download Games for iOS devices/Windows phone using this
        service?</p>
    <p>Games available are for primarily Android and feature phones only. Whereas IOS users & Android users both can
        playHTML5 games in their mobile browsers.</p>

    <p class="qes" style="font-weight: 700;">6. In which tariff plan will this service be applicable?</p>
    <p>This will be applicable in all tariff plan of Ncell prepaid and postpaid numbers.</p>

    <p class="qes" style="font-weight: 700;">7. Is my current phone capable of playing and downloading games?</p>
    <p>You can browse, play and download games from your phone that supports mobile data. You may check your phone
        compatibility by referring to your phone manual.</p>

    <p class="qes" style="font-weight: 700;">8. Is multiple subscription of different plan allowed?</p>
    <p>Multiple subscription of different plan is not allowed.</p>

    <p class="qes" style="font-weight: 700;">9. What happens if I have low balance at the time of subscribing to the
        service?
    </p>
    <p>To subscribe the service, you should have enough main balance in your account.</p>

    <p class="qes" style="font-weight: 700;">10. Will I be charged separately for downloading of games?</p>
    <p>The subscription plan rate for the service is only for access to the portal. You will be charged for data
        separately as per your plan for browsing or downloading gamesin the portal.</p>

    <p class="qes" style="font-weight: 700;">11. If I am not in coverage area but have WIFI, will I be able to play
        games?</p>
    <p>You can play the android games which have been downloaded and installed on your handset even if you are not
        connected to Ncell mobile data. For downloading games, you need to be in Ncell Cellular data.</p>

    <p class="qes" style="font-weight: 700;">12. Can I watch other games portal/apps from the subscription plan?</p>
    <p>The subscription fee will only work for the GamezinePlus service you have subscribed for.</p>

    <p class="qes" style="font-weight: 700;">13. Where and how do I access Mobile games offered from GamezinePlus on
        my mobile
        phone?</p>
    <p>Go to website http://GamezinePlus.matrixadz.com/ from your mobile browser (WAP / Services Browser) to browse
        the
        games available.You must have an internet connection on your smart / feature phone handset in order to
        access Mobile games from the GamezinePlus, to download and play games. If your handset is not compatible,
        sample
        trigger message will be displayed on the screen: "Sorry, there are no compatible contents for your handset
        at this time. We are continuously adding new handsets so please visit us later."</p>

    <p class="qes" style="font-weight: 700;">14. How to download the games from GamezinePlus?</p>
    <p>You can browse through the portal and download the available games apps from the portal by clicking the
        Download button.</p>

    <p class="qes" style="font-weight: 700;">15. How do I play the games?</p>
    <p>You can access the game/application folder on your phone to install the game, after installing the game one
        can enjoy playing the game.</p>

    <p class="qes" style="font-weight: 700;">16. Where can I find help/instructions on playing the games?</p>
    <p>You will find the game’s specific instructions within the game menu once you have downloaded and installed
        the game on your phone.</p>

</div>

<div class="container text-left mt-5" style="background-color: #13112E;
color: white;" *ngIf="queryParam.id === '544'">
    <p  style="text-align: left;">1. GamewinPlus is a subscription-based mobile gaming service that offers unlimited
        mobile games to download and play as long as you have an active subscription.</p>
    <p class="qes" style="font-weight: 700;">2. What are features of GamewinPlus?</p>
    <p>The GamewinPlus is available to all active smart / feature phone Ncell prepaid and postpaid subscribers who
        subscribe to any of the different game plans available. The subscribers can download and play one or all the
        games on their phones during the validity of the subscription/plan. GamewinPlus has more exciting games of
        different genres to engage users of different age groups. Once you are subscribed to GamewinPlus subscription
        service, you will need an active data connection to be able to validate your subscription status and
        download the games. Data charges will be applicable for downloading the selected games.</p>

    <p>You can subscribe/unsubscribe this service through SMS mode by following instructions mentioned below.</p>
    <p class="qes" style="font-weight: 700;">3. How can I opt for GamewinPlus Service in Web?</p>
    <p>You can subscribe to GamewinPlus service by selecting the pack on <a
            href="https://bit.ly/gamewnpls">http://gamewinplus.matrixadz.com/</a></p>

    <p class=" qes mt-3" style="font-weight: 500;"><u>How much do I pay for subscribing to GamewinPlus?</u></p>
    <p>1.You can subscribe to different subscription plans for GamewinPlus. It is available in both upfront (one time)
        and instalments packs as mentioned in table below.</p>
    <table class="table table-bordered" style="background-color: #13112E;
    color: white;">
        <thead>
            <tr>
                <th scope="col">Service packages</th>
                <th scope="col">Charging Type</th>
                <th scope="col">Validity</th>
                <th scope="col">Price Incl of Tax</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td scope="row">6 Month 3 Days Installment pack for Rs. 900</td>
                <td>Installment</td>
                <td>180</td>
                <td>15 per 3 day</td>
            </tr>
        </tbody>
    </table>

    <p class="qes" style="font-weight: 700;">4. Which platforms are supported for this service?</p>
    <p>Android, iOS &Java platforms are supported in this service.</p>

    <p class="qes" style="font-weight: 700;">5. Can I download Games for iOS devices/Windows phone using this service?</p>
    <p>Games available are for primarily Android and feature phones only. Whereas IOS users & Android users both can
        playHTML5 games in their mobile browsers.</p>

    <p class="qes" style="font-weight: 700;">6. In which tariff plan will this service be applicable?</p>
    <p>This will be applicable in all tariff plan of Ncell prepaid and postpaid numbers.</p>

    <p class="qes" style="font-weight: 700;">7. Is my current phone capable of playing and downloading games?</p>
    <p>You can browse, play and download games from your phone that supports mobile data. You may check your phone
        compatibility by referring to your phone manual.</p>

    <p class="qes" style="font-weight: 700;">8. Is multiple subscription of different plan allowed?</p>
    <p>Multiple subscription of different plan is not allowed.</p>

    <p class="qes" style="font-weight: 700;">9. What happens if I have low balance at the time of subscribing to the service?
    </p>
    <p>To subscribe the service, you should have enough main balance in your account.</p>

    <p class="qes" style="font-weight: 700;">10. Will I be charged separately for downloading of games?</p>
    <p>The subscription plan rate for the service is only for access to the portal. You will be charged for data
        separately as per your plan for browsing or downloading gamesin the portal.</p>

    <p class="qes" style="font-weight: 700;">11. If I am not in coverage area but have WIFI, will I be able to play games?</p>
    <p>You can play the android games which have been downloaded and installed on your handset even if you are not
        connected to Ncell mobile data. For downloading games, you need to be in Ncell Cellular data.</p>

    <p class="qes" style="font-weight: 700;">12. Can I watch other games portal/apps from the subscription plan?</p>
    <p>The subscription fee will only work for the GamewinPlus service you have subscribed for.</p>

    <p class="qes" style="font-weight: 700;">13. Where and how do I access Mobile games offered from GamewinPlus on my mobile
        phone?</p>
    <p>Go to website http://GamewinPlus.matrixadz.com/ from your mobile browser (WAP / Services Browser) to browse the
        games available.You must have an internet connection on your smart / feature phone handset in order to
        access Mobile games from the GamewinPlus, to download and play games. If your handset is not compatible, sample
        trigger message will be displayed on the screen: "Sorry, there are no compatible contents for your handset
        at this time. We are continuously adding new handsets so please visit us later."</p>

    <p class="qes" style="font-weight: 700;">14. How to download the games from GamewinPlus?</p>
    <p>You can browse through the portal and download the available games apps from the portal by clicking the
        Download button.</p>

    <p class="qes" style="font-weight: 700;">15. How do I play the games?</p>
    <p>You can access the game/application folder on your phone to install the game, after installing the game one
        can enjoy playing the game.</p>

    <p class="qes" style="font-weight: 700;">16. Where can I find help/instructions on playing the games?</p>
    <p>You will find the game’s specific instructions within the game menu once you have downloaded and installed
        the game on your phone.</p>

</div>
